import { AfterViewInit, Directive, ElementRef, Renderer2, inject, input } from '@angular/core';

/**
 * directive to free from boilerplate like <td><div class="m-caption">{{col.header}}</div></td>
 */
@Directive({
  selector: 'tr[appMobileTr]'
})
export class MobileTrDirective implements AfterViewInit {
  columns = input<{ header: string; }[]>([]);

  private el = inject(ElementRef<HTMLTableRowElement>);
  private renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    const cols = this.columns();
    if (!cols.length) {return;}

    const cells = this.el.nativeElement.querySelectorAll('td');

    cells.forEach((cell: HTMLTableCellElement, i: number) => {
      if (!cols[i]?.header || cell.querySelector('.m-caption')) {
        return;
      }

      this.insertCaption(cell, cols[i].header);
    });
  }

  insertCaption(cell: HTMLTableCellElement, header: string): void {
    const caption = this.renderer.createElement('div');
    this.renderer.addClass(caption, 'm-caption');

    const text = this.renderer.createText(header);
    this.renderer.appendChild(caption, text);

    this.renderer.insertBefore(cell, caption, cell.firstChild);
  }
}
